import { DateRange, LocalizedText } from '@common/models';
import { DatesService } from '@common/services/dates.service';

import { AlertApi } from '../../api/models';
import { DateTime } from 'luxon';
import { AlertType } from './alert-type';
import { NotfAlertConstants } from '../../notf.constants';

export class Alert
{
    title: LocalizedText;
    text: LocalizedText;
    rangeActivation: DateRange;
    periodIsValid: boolean;

    /**
     * Nature de l'alerte et couleur de fond personnalisee.
     * La nature s'appelle « alertType » et non « type » : les alertes voyagent dans des actions NgRx
     * qui reservent la propriete « type » pour leur propre discriminant. Le contrat d'API reste « type ».
     */
    alertType: AlertType | null = null;
    backgroundColor: string | null = null;

    get textFr () {
        return this.text['fr-FR'];
    }

    get textEn () {
        return this.text['en-US'];
    }

    get since () {
        return this.rangeActivation.since;
    }

    get until () {
        return this.rangeActivation.until;
    }

    constructor (public id: string, public active: boolean)
    {
    }

    public static mapperFromApi (source: AlertApi): Alert
    {
        const target = new Alert(source.id, source.active);

        const since = DateTime.fromISO(source.rangeActivation.since!, { setZone: true });
        const until = DateTime.fromISO(source.rangeActivation.until!, { setZone: true });
        target.rangeActivation = new DateRange(since, until);

        target.title = source.title;
        target.text = source.text;
        target.alertType = source.type ?? null;
        target.backgroundColor = NotfAlertConstants.isAllowedColor(source.backgroundColor) ? source.backgroundColor : null;

        return target;
    }
}
